import { Link } from "react-router-dom";
import { Phone, Globe, Radio, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export function ConnectServicesRow() {
  const { t } = useTranslation("common");

  const services = [
    {
      icon: Phone,
      title: t("svcCallingTitle"),
      desc: t("web.landing.callingServiceDesc"),
      to: "/#download",
      ctaLabel: t("web.nav.getTheApp"),
    },
    {
      icon: Globe,
      title: t("svcRatesTitle"),
      desc: t("svcRatesDesc"),
      to: "/connect-portal/rates",
    },
    {
      icon: Radio,
      title: t("svcRadioTitle"),
      desc: t("svcRadioDesc"),
      to: "/connect-portal/free-radio",
    },
  ];

  return (
    <section className="py-12 sm:py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-center mb-10">
          {t("ourServices")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 max-w-5xl mx-auto">
          {services.map(({ icon: Icon, title, desc, to, ctaLabel }) => (
            <Link key={to} to={to} className="group" aria-label={ctaLabel ?? title}>
              <Card className="h-full transition-all hover:shadow-md hover:border-primary/40">
                <CardContent className="p-6 flex flex-col h-full">
                  <div className="h-11 w-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-4">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="font-semibold text-lg mb-1.5">{title}</h3>
                  <p className="text-sm text-muted-foreground flex-1">{desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary">
                    {ctaLabel ?? title}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
